import React from 'react';
import {
  Button,
  ButtonGroup,
  Heading,
  IconFaceUnhappy,
  Page,
  PageContent,
  PageTitle,
  Paragraph,
  TextButton,
} from '@zillow/constellation';
import useQueryParams from '../../hooks/useQueryParams';
import { RENTAL_MANAGER_WEB } from '../../constants/paths';

export default function FailedRequestPage() {
  const { redirectUrl } = useQueryParams();

  return (
    <Page>
      <PageContent>
        <IconFaceUnhappy size="lg" />
      </PageContent>
      <PageTitle heading={<Heading level={1}>A problem occurred</Heading>} />
      <PageContent>
        <Paragraph>
          There’s been an error on our side, and we weren’t able to process your request.
          {redirectUrl && ' Please try again.'}
        </Paragraph>
      </PageContent>
      <PageContent>
        <ButtonGroup aria-label="Failed network request actions">
          {redirectUrl && (
            <Button as="a" buttonType="primary" id="try-again-button" href={decodeURIComponent(redirectUrl)}>
              Try again
            </Button>
          )}
          <TextButton as="a" id="go-to-your-properties-button" href={RENTAL_MANAGER_WEB}>
            Go to your properties
          </TextButton>
        </ButtonGroup>
      </PageContent>
    </Page>
  );
}
